import React from 'react';
import { Filter, Search } from 'lucide-react';
import { cn } from '@/lib/utils';

const CATEGORIES = ['all', 'contracts', 'compliance', 'litigation', 'research', 'general'];

/**
 * Category filter pills + search input combo for the workflows gallery.
 */
export function WorkflowFilters({
  category,
  onCategoryChange,
  search,
  onSearchChange,
  isArabic,
}) {
  const t = (en, ar) => (isArabic ? ar : en);
  const labelFor = (c) => {
    if (c === 'all')        return t('All', 'الكل');
    if (c === 'contracts')  return t('Contracts', 'عقود');
    if (c === 'compliance') return t('Compliance', 'امتثال');
    if (c === 'litigation') return t('Litigation', 'تقاضي');
    if (c === 'research')   return t('Research', 'بحث');
    return t('General', 'عام');
  };

  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-3 mb-4" data-testid="workflows-filters">
      <div className="relative flex-1">
        <Search className={cn('absolute top-1/2 -translate-y-1/2 w-4 h-4 hv-text-subtle', isArabic ? 'right-3' : 'left-3')} />
        <input
          type="text"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={t('Search workflows…', 'ابحث في سير العمل…')}
          className={cn(
            'w-full hv-border hv-surface-alt rounded text-sm py-2 hv-text focus:outline-none focus:hv-border-strong',
            isArabic ? 'pe-10 ps-3 text-right' : 'ps-10 pe-3'
          )}
          data-testid="workflows-search"
        />
      </div>
      <div className="flex items-center gap-1.5 flex-wrap" data-testid="workflows-category-pills">
        <Filter className="w-3.5 h-3.5 hv-text-subtle" />
        {CATEGORIES.map((c) => (
          <button
            key={c}
            onClick={() => onCategoryChange(c)}
            className={cn(
              'text-xs px-3 py-1 rounded-full transition-colors',
              category === c ? 'hv-btn-primary' : 'hv-border hover:hv-border-strong hv-text-muted'
            )}
            data-testid={`workflows-cat-${c}`}
          >
            {labelFor(c)}
          </button>
        ))}
      </div>
    </div>
  );
}

export default WorkflowFilters;
